<template>
<div>
  <section id="hero2" >
    <Slick ref="slick" :options="slickOptions" class="slick-item">
      <article style="background:#F1F8F8;">
          <div class="main-wraper">
            <a href="/quickmailhelp">
              <img src="/static/renew_img/bnr/mypage_top_banner_quickmail_20230222.png">
            </a>
          </div>
      </article>

      <article style="background:#F1F8F8;">
          <div class="main-wraper">
            <a href="/quickemailhelp">
              <img src="/static/renew_img/bnr/mypage_top_banner_quickemail_20230410.png">
            </a>
          </div>
      </article>
      <article style="background:#C1EEEE;">
          <div class="main-wraper">
            <a href="#">
            <!-- https://bit.ly/3aGWmcW -->
              <img src="/static/renew_img/bnr/hero1_20220509002.gif">
            </a>
          </div>
      </article>
      <article style="background:#F1F8F8;">
          <div class="main-wraper">
            <a href="https://www.yagish.jp/recruit/" target="_blank">
              <img src="/static/renew_img/bnr/mypage_top_banner_20230403.png">
            </a>
          </div>
      </article>
      <article style="background:#F6DBCA;">
          <div class="main-wraper">
            <a href="https://special.yagish.jp/recommend/index.html" target="_blank">
              <img src="/static/renew_img/bnr/hero6_20221005_001.gif">
            </a>
          </div>
      </article>
      <article style="background:#010043;">
          <div class="main-wraper">
            <a href="http://bit.ly/3OehI0B" target="_blank">
              <img src="/static/renew_img/bnr/hero6_20221118_001.png">
            </a>
          </div>
      </article>
      <!--
      <article style="background:#01604F;">
          <div class="main-wraper">
            <a href="https://blog.yagish.jp/entry/2022/09/13/142103?utm_source=blogWidget" target="_blank">
              <img src="/static/renew_img/bnr/hero2_marketing_20220916_001.png">
            </a>
          </div>
      </article>
      <article style="background:#E61616;">
          <div class="main-wraper">
            <a href="https://bit.ly/3aGWmcW" target="_blank" >
              <img src="/static/renew_img/bnr/top_banner_20220401_001.gif">
            </a>
          </div>
      </article>
      <article style="background:#FFFFFF;">
          <div class="main-wraper">
            <a href="https://blog.yagish.jp/entry/2022/09/14/105320?utm_source=blogWidget" target="_blank">
              <img src="/static/renew_img/bnr/hero2_designer_20220916_001.png">
            </a>
          </div>
      </article> -->
      <!-- <article style="background:#FFC051;" v-if="is_not_midnight">
          <div class="main-wraper">
            <a href="https://bit.ly/3uT6SV6" target="_blank">
              <img src="/static/renew_img/bnr/top_banner_20220305_001.gif">
            </a>
          </div>
      </article> -->
    </Slick>
  </section>
  <section id="navlist">
    <div class="content-wrapper">
      <h2>はじメェ～まして！<br>まずは職務経歴書を選んでね！</h2>
      <div class="input-middle" v-if="recentEdit.FormatId !== ''">
        <template v-if="recentEdit.FormatId !== ''">
          <p>途中まで入力した<br class="sp">キャッシュデータが残っています</p>
          <div class="btn_wrapper">
            <router-link :to="{name: 'formatEditCard', params: { formatId: recentEdit.FormatId, cardId: recentEdit.cardId }}"
                        v-ripple>
              <a class="btn_cta">続きを入力する</a>
            </router-link>
          </div>
          <div class="btn_wrapper">
            <router-link :to="{name: 'formatPreview', params: { formatId: recentEdit.FormatId, cardId: recentEdit.cardId }}"
                        v-ripple>
              <a class="btn_sub">仕上がりを確認する</a>
            </router-link>
          </div>
        </template>
      </div>
      <article class="flex-box">
        <div class="flex-item"
           :key="f.id"
           v-for="f in $site.keirekishoFormatsIndex"
           :class="recentEditClass(f)"
           style="line-height:1;">
          <p class="tag" v-if="f.id === 'rirekisho_job_change'">おすすめ</p>
          <div class="img_base">
            <img :src="f.thumbnail"
                :alt="f.title + 'テンプレート'">
          </div>
          <p class="title">{{ f.title }}</p>
          <ul>
            <li >{{ f.newdetail1 }}</li>
            <li v-if="f.newdetail2 != ''">{{ f.newdetail2 }}</li>
            <li >{{ f.newdetail3 }}</li>
          </ul>
          <router-link :to="{name: 'formatDetail', params: { formatId: f.id }}"
                    v-if="f.id != 'letter' && f.id != 'shokumukeirekisho'">この履歴書で作る
          </router-link>
          <router-link :to="{name: 'formatDetail', params: { formatId: f.id }}"
                    style="background-color:orange"
                    v-else-if="f.id != 'shokumukeirekisho'">送付状を作る
          </router-link>
          <router-link :to="{name: 'formatDetail', params: { formatId: f.id }}"
                    v-else
                    style="background-color:rgb(15, 153, 52)">職務経歴書を作る
          </router-link>
        </div>
      </article>
    </div>
  </section>
  <section id="about">
    <div class="content-wrapper">
      <h2><span>ヤギッシュとは？</span></h2>
      <img src="/static/renew_img/about_pc.png" alt="PC、スマホ、タブレットで無料で履歴書が作れちゃうよ！" class="pc">
      <img src="/static/renew_img/about_sp.png" alt="PC、スマホ、タブレットで無料で履歴書が作れちゃうよ！" class="sp">
      <p>
        yagish（ヤギッシュ）は、ブラウザ上で履歴書がつくれる無料サービスです。<br>
        転職用、新卒用、アルバイト用など多数のテンプレートを用意。<br>
        外出先でも、必要なときにいつでも履歴書を作成でき、作成した履歴書はダウンロードやコンビニ印刷も可能！
      </p>
    </div>
  </section>
  <section id="howto">
    <div class="content-wrapper">
      <h2><span>ヤギッシュの使い方</span></h2>
      <img src="/static/renew_img/howto_pc.png" alt="3ステップで入力〜印刷までブラウザ完結" class="pc step">
      <img src="/static/renew_img/howto_sp.png" alt="3ステップで入力〜印刷までブラウザ完結" class="sp step">
      <img src="/static/renew_img/flow_pc.png" class="pc flow" alt="1.履歴書選択、2.履歴書入力 3.コンビニ印刷かpdfダウンロード">
      <img src="/static/renew_img/flow_sp.png" class="sp flow" alt="1.履歴書選択、2.履歴書入力 3.コンビニ印刷かpdfダウンロード">
      <a class="btn_sub" href="/info" >もっと詳しくみる<img src="/static/renew_img/icon_link.svg" alt="ヤギッシュの使い方を詳しく見る"></a>
      <article v-if="!$firebase.isAuthenticated">
        <p class="title">ログインすると<br><span>さらに</span>便利に使える！</p>
        <img src="/static/renew_img/login-merit.png" alt="1.履歴書のバックアップ 2.コンビニ印刷が可能に">
        <p>※対応しているコンビニは、セブンイレブン・ファミリーマート・ローソンなど全国58,000店舗以上で、印刷は有料となります。</p>
        <div class="btn_wrapper">
          <a class="btn_cta " href="/login">ログインする<img src="/static/renew_img/icon_login.svg" alt="ログイン"></a>
        </div>
      </article>
    </div>
  </section>
  <blog-widget :json-url="$site.blogJsonUrl" v-if="false"></blog-widget>
</div>
</template>
<style scoped>
@import "/static/css/slick-theme.css";
@import "/static/css/slick.css";
</style>

<script>
import blogWidget from '@/components/BlogWidget'
import YagiOmikuji from '@/components/Omikuji'
import Slick from 'vue-slick'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'
export default {
  components: {
    'blog-widget': blogWidget,
    'yagi-omikuji': YagiOmikuji,
    Slick
  },
  data: function () {
    return {
		  is_not_midnight: true,
      recentEdit: {
        FormatId: ''
      },
      slickOptions: {
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 400
      }
    }
  },
  methods: {
    reload: function () {
      location.reload(true)
    },
    recentEditClass: function (format) {
      if (!this.recentEdit) return
      if (this.recentEdit.FormatId === format.id) {
        return {
          'current-edit': true
        }
      }
    },
    loadRecentEdit: function () {
      const app = this
      this.$getItem(RECENT_EDIT_SAVE_KEY, function (err, data) {
        if (err) {
          console.log(err)
        }
        if (data) {
          app.recentEdit = data
        }
      })
    },
    updateRecentEdit: function (data) {
      if (data) {
        this.recentEdit = data
      }
    }
  },
  created: function () {
    // console.error(this.$deviceLib.getUserAgent.substring(0, 190))
    this.loadRecentEdit()
    const now = new Date()
    if (now.getHours() >= 0 && now.getHours() < 6) {
      this.is_not_midnight = false
    }
    this.$eventHub.$on('change-recent-edit', this.updateRecentEdit)
    this.$eventHub.$on('reload', this.reload)
  },
  destroyed: function () {
    this.$eventHub.$off('change-recent-edit', this.updateRecentEdit)
    this.$eventHub.$off('reload', this.reload)
  }
}
</script>
